module.exports = __webpack_public_path__ + "static/media/7.555656b1.jfif";